import { Skeleton, Stack } from "@mui/material";

type Props = {};

const ZoneTabsLoadingMobile = (props: Props) => {
  return (
    <Stack direction={"row"} spacing={2} justifyContent={"center"}>
      <Skeleton variant="rectangular" width={50} height={30}></Skeleton>
      <Skeleton variant="rectangular" width={50} height={30}></Skeleton>
      <Skeleton variant="rectangular" width={50} height={30}></Skeleton>
      <Skeleton variant="rectangular" width={50} height={30}></Skeleton>
    </Stack>
  );
};

export default ZoneTabsLoadingMobile;
